<script setup lang="ts">
import MoneyAmount from '@/app/components/MoneyAmount.vue'
import { formatMoney, type Money } from '@taler/domain'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { MoneyTone } from '../internal/transaction-row.ts'

const props = withDefaults(
  defineProps<{
    total: Money | undefined
    nativeTotal?: Money | undefined
    rateMissing?: boolean
    tone?: MoneyTone | undefined
    sign?: boolean
  }>(),
  { nativeTotal: undefined, rateMissing: false, tone: undefined, sign: false },
)

const { locale, t } = useI18n()

const nativeText = computed(() =>
  props.nativeTotal === undefined
    ? undefined
    : formatMoney(props.nativeTotal, { locale: locale.value as 'en' | 'hu', sign: props.sign }),
)
</script>

<template>
  <div class="flex flex-col items-end">
    <MoneyAmount v-if="total !== undefined" :value="total" :sign="sign" :tone="tone" />
    <p v-else class="text-[color:var(--color-text-muted)]">—</p>
    <p
      v-if="nativeText !== undefined"
      class="whitespace-nowrap text-[length:var(--text-step-1)] tabular-nums text-[color:var(--color-text-muted)]"
    >
      {{ nativeText }}
    </p>
    <p
      v-else-if="rateMissing"
      class="text-[length:var(--text-step-1)] italic text-[color:var(--color-text-muted)]"
    >
      {{ t('transactions.noRateForDate') }}
    </p>
  </div>
</template>
